<template>
  <div v-if="visual" class="rain-presentation" role="region" aria-label="红包雨场次展示">
    <div v-if="visual.noticeTitle || visual.noticeContent" class="rain-notice">
      <h3 v-if="visual.noticeTitle">{{ visual.noticeTitle }}</h3>
      <p v-if="visual.noticeContent">{{ visual.noticeContent }}</p>
    </div>
    <div v-if="visual.imageUrl" class="rain-scene">
      <img class="rain-scene-image" :src="visual.imageUrl" :alt="visual.imageAlt" :aria-label="visual.imageAlt" />
      <div v-if="visual.fallingUrl" class="rain-shower" aria-hidden="true">
        <img v-for="item in 4" class="rain-drop" :key="item" :src="visual.fallingUrl" alt="" />
      </div>
    </div>
    <img v-if="visual.bannerUrl" class="rain-banner" :src="visual.bannerUrl" alt="红包雨场次通知" aria-label="红包雨场次通知" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { rainPresentationView } from '../../services/activities/gameplay.mjs';
const props = defineProps({ presentation: { type: Object, default: null }, status: { type: String, default: 'WAITING' }, seconds: { type: Number, default: 0 } });
const visual = computed(() => rainPresentationView(props.presentation, props.status, props.seconds));
</script>

<style scoped>
.rain-presentation { display: grid; gap: 12px; margin: 4px 0 20px; }
.rain-notice { display: grid; gap: 6px; padding: 14px 16px; border-radius: 12px; background: var(--kg-primary-soft, #edf7ff); color: var(--kg-text, #303442); overflow-wrap: anywhere; }
.rain-notice h3 { margin: 0; font-size: 16px; font-weight: 600; line-height: 1.5; }
.rain-notice p { margin: 0; font-size: 14px; line-height: 1.7; }
.rain-scene { position: relative; min-width: 0; overflow: hidden; border-radius: 12px; }
.rain-scene-image { display: block; width: 100%; height: 190px; object-fit: contain; }
.rain-banner { display: block; width: 100%; height: 56px; object-fit: contain; }
.rain-shower { position: absolute; inset: 0; overflow: hidden; pointer-events: none; }
.rain-drop { position: absolute; top: -40px; width: 28px; height: 32px; object-fit: contain; opacity: 0; animation: rain-fall 3s linear infinite; }
.rain-drop:nth-child(1) { left: 15%; }
.rain-drop:nth-child(2) { left: 38%; animation-delay: .7s; }
.rain-drop:nth-child(3) { left: 62%; animation-delay: 1.4s; }
.rain-drop:nth-child(4) { left: 82%; animation-delay: 2.1s; }
@keyframes rain-fall { 10% { opacity: .85; } 90% { opacity: .85; } to { transform: translateY(235px) rotate(20deg); opacity: 0; } }
@media (prefers-reduced-motion: reduce) { .rain-shower { display: none; } }
</style>
